// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Field plus its Help link. inline-flex so the component still drops into
   the flex rows and toolbars that used to receive a bare TextField. */
.seachField_wrapper__o5g5K {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.seachField_searchField__e9iho {
  display: flex;
  flex-direction: row;
  width: 12em;
  border: 0;
  border-radius: 0;
  background: #fff;
}

/* The return glyph shown while a typed term has not been searched yet. */
.seachField_pendingHint__rcDMB {
  font-size: 0.9rem;
  line-height: 1;
  opacity: 0.55;
  padding-right: 0.15rem;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchField/seachField.module.css"],"names":[],"mappings":"AAAA;sEACsE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":["/* Field plus its Help link. inline-flex so the component still drops into\n   the flex rows and toolbars that used to receive a bare TextField. */\n.wrapper {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.searchField {\n  display: flex;\n  flex-direction: row;\n  width: 12em;\n  border: 0;\n  border-radius: 0;\n  background: #fff;\n}\n\n/* The return glyph shown while a typed term has not been searched yet. */\n.pendingHint {\n  font-size: 0.9rem;\n  line-height: 1;\n  opacity: 0.55;\n  padding-right: 0.15rem;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `seachField_wrapper__o5g5K`,
	"searchField": `seachField_searchField__e9iho`,
	"pendingHint": `seachField_pendingHint__rcDMB`
};
export default ___CSS_LOADER_EXPORT___;
